/** 泛型对象池：约定 T 带布尔字段 active。消费者遍历全量并跳过 inactive。 */

interface Activatable {
  active: boolean;
}

export class ObjectPool<T extends Activatable> {
  private readonly items: T[] = [];

  constructor(
    private readonly factory: () => T,
    size: number,
  ) {
    for (let i = 0; i < size; i++) {
      const it = factory();
      it.active = false;
      this.items.push(it);
    }
  }

  obtain(): T {
    for (let i = 0; i < this.items.length; i++) {
      const it = this.items[i] as T;
      if (!it.active) {
        it.active = true;
        return it;
      }
    }
    const grown = this.factory();
    grown.active = true;
    this.items.push(grown);
    return grown;
  }

  release(item: T): void {
    item.active = false;
  }

  /** 返回全量（含 inactive），调用方自行检查 active，避免每帧分配数组。 */
  all(): readonly T[] {
    return this.items;
  }

  get length(): number {
    return this.items.length;
  }
}
